import { DatePipe } from "@angular/common";
import { Component, computed, inject, OnDestroy, OnInit, Signal } from "@angular/core";
import { SortDirection } from "@src/app/shared/enums";
import { MaintenanceModeResponse } from "@src/app/shared/services";
import { Pollable, PollingManagerService } from "@src/app/shared/services/polling-manager/polling-manager.service";
import { compareTimes } from "@src/app/shared/utils";
import { MaintenanceModeStore } from "@src/app/core/components/maintenance-mode/maintenance-mode.store";

@Component({
  selector: 'cs-maintenance-mode',
  imports: [
    DatePipe
  ],
  providers: [
    MaintenanceModeStore
  ],
  template: `
  @if (isInMaintenanceMode()) {
    <div class="bg-neutral-500 py-1 text-center font-bold text-white">
      @if (maintenanceMode().customMessage) {
        {{ maintenanceMode().customMessage }}
      } @else {
        We will be performing maintenance from {{ maintenanceModeStartTime() | date: dateFormat }} to {{ maintenanceModeEndTime() | date: dateFormat }}.
      }
    </div>
  }
    `
})
export class MaintenanceModeNotificationComponent implements OnInit, OnDestroy, Pollable {
  public dateFormat: string = 'MMM d, h:mm a';
  readonly pollingKey: string = 'maintenance-mode';
  public readonly maintenanceModeStore = inject(MaintenanceModeStore);
  maintenanceMode: Signal<MaintenanceModeResponse> = computed(() => this.maintenanceModeStore.maintenanceMode());
  
  private pollingManager: PollingManagerService = inject(PollingManagerService);

  public isInMaintenanceMode = computed<boolean>(() => {
    return this.maintenanceMode().isOn &&
      compareTimes(new Date(Date.now()).toISOString(), this.maintenanceMode().endTime, SortDirection.DESC) > 0;
  });

  public maintenanceModeStartTime = computed<string | Date >(() => {
    return this.maintenanceMode().startTime as Date;
  });

  public maintenanceModeEndTime = computed<string | Date>(() => {
    return this.maintenanceMode().endTime as Date;
  });

  ngOnInit(): void {
    this.pollingManager.registerActionForPolling(this);
  }

  ngOnDestroy(): void {
    this.pollingManager.delistActionForPolling(this);
  }

  poll(): void {
    this.maintenanceModeStore.getMaintenanceMode();
  }

}